// src/pages/Termeni.jsx
import React from "react";
import { motion } from "framer-motion";
import Title from "../components/ui/Title";
import SectionTitle from "../components/ui/SectionTitle";
import CardContainer from "../components/ui/CardContainer";

export default function Termeni() {
  const sections = [
    {
      titlu: "1. Proprietar și responsabilitate",
      continut:
        "Site-ul traiestetidesignul.ro este deținut și administrat de Corina Loredana Nedelcu PFA. Toate activitățile, conținutul și serviciile publicate sunt responsabilitatea exclusivă a acestui titular.",
    },
    {
      titlu: "2. Scopul site-ului",
      continut:
        "Acest site oferă informații, reflecții și servicii legate de sistemul Human Design, într-un cadru autentic, educativ și inspirațional. Nu oferă diagnostice medicale, psihologice sau garanții de rezultate.",
    },
    {
      titlu: "3. Drepturi de autor și conținut original",
      continut:
        "Toate materialele de pe site – texte, imagini, ghiduri, denumiri originale – sunt protejate de drepturile de autor și nu pot fi copiate, distribuite sau reproduse fără acordul scris al Corinei Loredana Nedelcu PFA.",
    },
    {
      titlu: "4. Comunicare prin formular",
      continut:
        "Datele trimise prin formularul de contact (nume, email, mesaj) sunt folosite strict pentru a răspunde solicitării. Nu sunt stocate într-o bază de date și nu sunt transmise către terți.",
    },
    {
      titlu: "5. Confidențialitate și protecția datelor",
      continut:
        "Site-ul respectă principiile de confidențialitate. Nu se colectează automat date personale în scopuri de marketing. Subscrierea la newsletter (prin Substack) este voluntară și gestionată extern.",
    },
    {
      titlu: "6. Modificări și actualizări",
      continut:
        "Corina Loredana Nedelcu PFA își rezervă dreptul de a modifica structura, conținutul sau politica de funcționare a site-ului, fără notificare prealabilă. Orice schimbare intră în vigoare din momentul publicării.",
    },
  ];

  return (
    <motion.div
      className="p-6 md:p-12 max-w-4xl mx-auto"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
    >
      <Title>Termeni și condiții</Title>

      <div className="grid gap-6">
        {sections.map((sec, index) => (
          <CardContainer key={index}>
            <SectionTitle>{sec.titlu}</SectionTitle>
            <p className="text-text-body leading-relaxed">{sec.continut}</p>
          </CardContainer>
        ))}
      </div>

      <p className="mt-12 text-sm text-center text-gray-400 italic">
        Ultima actualizare: iunie 2025
      </p>
    </motion.div>
  );
}
